import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/home/Home'
//auth routes
import Signup from '@/components/auth/Signup'
import Login from '@/components/auth/Login'
//admin routes
import Admin from '@/components/admin/Panel'
import EditUsers from '@/components/admin/EditUsers'
import EditUser from '@/components/admin/EditUser'
import NewImprovements from '@/components/admin/NewImprovements'
import Improvements from '@/components/admin/Improvements'
import EditImprovement from '@/components/admin/EditImprovement'
import ShowImprovement from '@/components/admin/ShowImprovement'
import Archive from '@/components/admin/Archive'
//user routes
import Idea from '@/components/home/Idea'
import Improvement from '@/components/home/Improvement'
import Declared from '@/components/home/Declared'

import firebase from 'firebase'

Vue.use(VueRouter)

const router =  new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,

    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta:{
                requiresAuth: true
            }
        },
        //auth routes
        {
            path: '/signup',
            name: 'Signup',
            component: Signup,
            meta:{
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        //admin routes
        {
            path: '/admin',
            name: 'Admin',
            component: Admin,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/new-improvements',
            name: 'NewImprovements',
            component: NewImprovements,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/improvements',
            name: 'Improvements',
            component: Improvements,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/archive',
            name: 'Archive',
            component: Archive,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/edit-improvement/:ref',
            name: 'EditImprovement',
            component: EditImprovement,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/show-improvement/:ref',
            name: 'ShowImprovement',
            component: ShowImprovement,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/edit_users',
            name: 'EditUsers',
            component: EditUsers,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/edit-user/:user_slug',
            name: 'EditUser',
            component: EditUser,
            meta: {
                requiresAuth: true
            }
        },
        //user routes
        {
            path: '/idea',
            name: 'Idea',
            component: Idea,
            meta:{
                requiresAuth: true
            }
        },
        {
            path: '/improvement',
            name: 'Improvement',
            component: Improvement,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/declared',
            name: 'Declared',
            component: Declared,
            meta: {
                requiresAuth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    //check if route requires auth
    if(to.matched.some(rec => rec.meta.requiresAuth)){
        //check auth state of user
        let user = firebase.auth().currentUser
        if(user){
            //user signed in proceed to route
            next()
        }else{
            // no user signed in redirect to login
            next({ name: 'Login' })
        }
    }else{
        next()
    }
})

export default router
